(function() {
  'use strict';

  angular
    .module('eclipseApp.checkout')

    .controller('buyPaymentOptionsCtrl', [
      '$scope',
      '$http',
      'uteEndpoint',
      '$state',
      '$rootScope',
      '$timeout',
      'paymentOptionsCreds',
      'buyService',
      'notifier',
      'buyUtils',
      'uteSemafoneService',
      'dtmService',
      'dtmServiceConstants',
      'cartManager',
      'commonService',
      'brtSwitchCMS',
      function(
        $scope,
        $http,
        uteEndpoint,
        $state,
        $rootScope,
        $timeout,
        paymentOptionsCreds,
        buyService,
        notifier,
        buyUtils,
        uteSemafoneService,
        dtmService,
        dtmServiceConstants,
        cartManager,
        commonService,
        brtSwitchCMS
      ) {
        var _self = this;
        _self.ccData = {};
        _self.selectedPaymentOption = $scope.forms.paymentOptions.selectedPaymentOption || '';
        _self.isNewPACC = false;
        _self.ccToken = null;
        _self.accountNumber = buyService.getAccountNumberByServiceName('wireless');

        $scope.brtSwitchCMS = brtSwitchCMS;
        $scope.serverResponse = {};

        $scope.formData = {
          pacc: {},
          invoice: {},
          pac: {}
        };
        $scope.addNewClass = false;
        $scope.hasBeenSubmitted = false;
        console.log('@buyPaymentOptionsCtrl (_self.accountNumber) ', _self.accountNumber);

        //FUSS-1520 - DTM tracking for payment option step 4
        var tierInCart = cartManager.internet.tierInCart();
        if (tierInCart) {
          if (tierInCart.selectedOffer && tierInCart.selectedOffer.offerPrice) {
            dtmService.setVar(
              dtmServiceConstants.dtmRules.buyInternet.selectedProduct,
              tierInCart.selectedOffer.offerId
            );
            dtmService.setVar(
              dtmServiceConstants.dtmRules.buyInternet.productPrice,
              tierInCart.selectedOffer.offerPrice.price
            );
          }
          dtmService.direct(dtmServiceConstants.dtmRules.buyInternet.paymentOptions.ruleName);

          /* DSO-15392 start */
          if ($rootScope.promoOfferId === null || $rootScope.discountOffers === null) {
            if (
              commonService.customerHasInternetService &&
              commonService.internetAccountStatus !== 'SUSPENDED' &&
              commonService.internetAccountStatus !== 'CANCELLED'
            ) {
            } else {
              var isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
              if (isOfferIdEligible === null) {
                buyService.getInternetPromos().then(function(data) {
                  if (data) {
                    isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
                    $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                    $rootScope.discountOffers = buyService.getDiscountOffers();
                  }
                });
              } else {
                $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                $rootScope.discountOffers = buyService.getDiscountOffers();
              }
            }
          } else if (tierInCart && $rootScope.discountOffers === null && !$rootScope.ruiMethods.user.is.loggedIn()) {
            buyService.getInternetPromos().then(function(data) {
              $scope.discountOffers = data;
            });
          }
          /* DSO-15392 end */
        }

        if ($rootScope.ruiMethods.user.is.loggedIn() && $rootScope.ruiMethods.user.is.agent() && _self.accountNumber) {
          buyService.getPaymentDetails(_self.accountNumber).then(function(resp) {
            /*
             * @if
             * @description handle if response.data.paymentMethod == INVOICE and CX received a conditional-approval type
             * of credit-risk-class which an option to invoice will not be applicable which
             * will default to `Online and no payment-method selected
             */
            if (
              resp.data.paymentMethod.toLowerCase() == 'invoice' &&
              $scope.forms.creditCheck.allowPAC &&
              $scope.forms.creditCheck.riskClassName == 'CONDITIONAL_APPROVAL'
            )
              return;

            _self.selectedPaymentOption = resp.data.paymentMethod.toLowerCase();
            $scope.forms.paymentOptions.billingMethod = resp.data.billingMethod.toLowerCase();

            console.log('@buyPaymentOptionsCtrl: IFROOT case loggedin (resp)', resp);
          });
        } else {
          _self.selectedPaymentOption = 'pacc'; //Added for Fido 100% Billing project
        }

        // if user navigates back to paymentOptions from review
        // if ($scope.forms.paymentOptions.__completed || $scope.forms.review.isTouched) {
        //   console.log('@buyPaymentOptionsCtrl:on paymentOptions.__completed ', _self);
        //   // if pacc is chosen as paymentOption
        //   if (_self.selectedPaymentOption && _self.selectedPaymentOption === 'pacc') {

        //     // if previous cc was chosen on submit
        //     // fetch: credit card
        //     // then: reflect to view

        //     fetchPreviousCC();
        //   }

        // }
        _.defer(function() {
          //console.log('$broadcast.setSelectedPaymentOption');
          $scope.$broadcast('setSelectedPaymentOption', { type: _self.selectedPaymentOption });
          $scope.$apply();
        });

        $scope.hasCreditCard = function() {
          var _firstId = $scope.forms.creditCheck.data.firstIdOption,
            _secondId = $scope.forms.creditCheck.data.secondIdOption;

          return _.includes([_firstId, _secondId], '1');
        };
        $scope.toggleSubmittedValue = function() {
          $scope.hasBeenSubmitted = false;
        };

        $scope.confirmPaymentOptions = function(formName) {
          $scope.addNewClass = true;
          $scope.hasBeenSubmitted = true;

          console.log('@@@@@@@@@@@', $scope.hasBeenSubmitted);

          //DSO-12647 scroll to the first error
          $timeout(function() {
            var errorList = document.getElementsByClassName('ute-message error ng-active');
            var ccError = document.getElementById('semafoneError');
            if (ccError && ccError.getClientRects().length > 0) {
              var yPos = ccError.getClientRects()[0].top;
              var scrollValue =
                yPos -
                document.getElementsByClassName('create-profile-menu-holder')[0].offsetHeight -
                document.getElementById('header').offsetHeight -
                95;
              window.scrollBy(0, scrollValue);
            } else if (errorList.length > 0) {
              var iElement = 0;
              while (errorList[iElement].getClientRects().length <= 0 && errorList.length > iElement) {
                iElement++;
              }
              if (errorList[iElement] && errorList[iElement].getClientRects().length > 0) {
                var yPos = errorList[iElement].getClientRects()[0].top;
                var scrollValue =
                  yPos -
                  document.getElementsByClassName('create-profile-menu-holder')[0].offsetHeight -
                  document.getElementById('header').offsetHeight -
                  95;
                window.scrollBy(0, scrollValue);
              }
            }
          });

          formName.$setSubmitted();

          angular.forEach(['invoice', 'formPacc', 'formPac'], function(v) {
            if (!formName[v]) {
              console.log('@buyPaymentOptionsCtrl:confirmPaymentOptions(): NO METHOD SELECTED! ');
              return;
            }
          });

          $scope.$broadcast('validateMethod');
        };

        $scope.$on('PaymentOptions:Events:NewCC', function(ev, data) {
          if (data.isNewPACC) {
            console.log('@buyPaymentOptionsCtrl:$on.PO:CHANGE_CREDIT_CARD:IF');
            _self.isNewPACC = true;
            $scope.formData.pacc = {};
          } else if (!data.isNewPACC) {
            console.log('@buyPaymentOptionsCtrl:$on.PO:CHANGE_CREDIT_CARD:ELSEIF');
            _self.isNewPACC = false;

            // user submit using the previous entered creditcart
            angular.copy(_self.ccData, $scope.formData.pacc);
          }
        });

        $scope.$on('methodValidated', function(ev, methodInfo) {
          var reqData = {};
          var ccNumber, ccExpiryMonth;

          // if ($scope.hasCreditCard()) {
          //   if (_self.isNewPACC) {
          //     ccNumber = methodInfo.data.ccNumber;
          //   } else if (!_self.isNewPACC) {
          //     ccNumber = _self.ccNumber;
          //   }
          // } else if (!$scope.hasCreditCard()) {
          //   ccNumber = methodInfo.data.ccNumber;
          // }

          ccExpiryMonth = buyUtils.formatNumber(methodInfo.data.ccExpiryMonth);

          if ($scope.hasCreditCard()) {
            console.log('@buyPaymentOptionsCtrl:hasCC');
            if (_self.isNewPACC) {
              console.log('@buyPaymentOptionsCtrl:isNewPACC');
              ccNumber = methodInfo.data.ccNumber;
            } else if (!_self.isNewPACC) {
              console.log('@buyPaymentOptionsCtrl:not.isNewPACC');
              ccNumber = _self.ccNumber;
              ccExpiryMonth = methodInfo.data.ccExpiryMonth;
            }
          } else if (!$scope.hasCreditCard()) {
            console.log('@buyPaymentOptionsCtrl:not.hasCC');
            ccNumber = methodInfo.data.ccNumber;
          }

          notifier.notify.processing();

          console.log('methodValidated', methodInfo);

          $scope.forms.paymentOptions.selectedPaymentOption = methodInfo.type;

          console.log('@methodValidated:success ', methodInfo);
          console.log('@methodValidated:$scope ', $scope);

          if ($scope.forms.paymentOptions.billingMethod === 'online') {
            angular.extend(reqData, { 'billingDetails.onlineBillEmail': $scope.forms.createUser.email_address });
          }

          // include type of billing method chosen at all times
          angular.extend(reqData, {
            mopType: methodInfo.type,
            'billingDetails.billLanguage': $scope.forms.createUser.language,
            billingMethod: $scope.forms.paymentOptions.billingMethod,
            financialAccountID: $scope.forms.paymentOptions.data.financialAccountID
              ? $scope.forms.paymentOptions.data.financialAccountID
              : null,
            edit: $scope.forms.paymentOptions.submitted,
            barId: $scope.forms.paymentOptions.data.billingArrangementId
              ? $scope.forms.paymentOptions.data.billingArrangementId
              : null
          });

          switch (methodInfo.type) {
            case 'invoice':
              break;
            case 'pac':
              angular.extend(reqData, {
                'bankDetails.bankCode': methodInfo.data.bankCode,
                'bankDetails.bankName': methodInfo.data.bankName,
                'bankDetails.bankAccountNo': methodInfo.data.accountNumber,
                'bankDetails.bankBranchNo': methodInfo.data.transitCode
              });
              break;
            case 'pacc':
              angular.extend(reqData, {
                'creditCardInfo.ccNumber': ccNumber,
                'creditCardInfo.ccExpiryYear': methodInfo.data.ccExpiryYear,
                'creditCardInfo.ccExpiryMonth': ccExpiryMonth,
                'creditCardInfo.ccType': buyUtils.getCCType().byName(methodInfo.data.ccType),
                'creditCardInfo.securityCode': methodInfo.data.cvv
              });
              break;
            default:
          }

          buyService.createFinancialAccount({ data: reqData }).then(
            function(data) {
              console.log('createFinancialAccount:Success ', data);

              buyService.setCheckoutMode(false);

              // set submitted
              $scope.forms.paymentOptions.submitted = true;

              angular.extend($scope.forms.paymentOptions.data, data);

              // $scope.completedForm('paymentOptions');

              buyService.getOrderSummary(data).then(
                function(res) {
                  angular.extend($scope.forms.review.data, res);
                  $scope.completedForm('paymentOptions');
                },
                function(res) {
                  // if /orderSummary failed clear the cached credit card in semafoneService
                  // and do not prepopulate
                  uteSemafoneService.clearData();
                }
              );
            },
            function(res) {
              if (res.error) {
                _satellite.setVar('error', 'FHSI | paymentoption failed');
                _satellite.track('bfa-fhsi-error');
                switch (res.error) {
                  case '60003':
                    $scope.serverResponse.invalidBankInfo = {};

                    console.log('case 60003 ', $scope);

                    if ($scope.formData.selectedPaymentOption) {
                      if ($scope.formData.selectedPaymentOption === 'pac') {
                        $scope.rootPaymentOptions.formPac.transitCode.$setValidity('invalidTransitCode', false);
                        $scope.rootPaymentOptions.formPac.bankCode.$setValidity('invalidBankCode', false);
                      }
                    }
                }
              }
              console.log('createFinancialAccount:Error ', res);
            }
          );
        });

        $scope.$on('methodValidatedError', function(ev, data) {
          console.log('@paymentOptions:$on.methodValidatedError:data', data);
          if (!data.type) {
            $scope.invalidBillingMethod = true;
          } else if (data.type && data.type === 'pacc') {
            notifier.notify.error({ errorCode: 'cybinvalid' });
          }
        });

        $scope.$on('PaymentOptions:SelectedMethod', function(e, data) {
          console.log('@buyPaymentOptionsCtrl.$on.PaymentOptions:SelectedMethod:data ', data);
          if (
            data &&
            data.selectedPaymentMethod === 'pacc' &&
            $scope.hasCreditCard() &&
            !$scope.forms.review.isTouched
          ) {
            // fetch cc info
            // set props
            fetchPreviousCC();
          }
        });

        function fetchPreviousCC() {
          // debug
          // var res = {ccNumber:'9604184769591234',ccType:'V',ccExpiryDate:'09-2018'};

          // _self.ccData = {
          //   ccMasked: uteCyberSource.getMaskedToken(res.ccNumber),
          //   ccExpiryYear: res.ccExpiryDate.split('-')[1],
          //   ccExpiryMonth: res.ccExpiryDate.split('-')[0],
          //   ccType: buyUtils.getCCType().byFirstChar(res.ccType)
          // };
          // _self.ccNumber = res.ccNumber;

          // angular.copy(_self.ccData, $scope.formData.pacc);
          // return ;
          // end debug

          // fetch previous selected credit card
          buyService.searchCreditCard().then(
            function(res) {
              console.log('@paymentOptions:@$on.PaymentOptions:SelectedMethod.SUCCESS ', res);

              // NOTE view structure
              // _self.ccData = {
              //   ccMasked: '**** **** **** 8907',
              //   ccExpiryMonth: '07',
              //   ccExpiryYear: '2016',
              //   ccType: 'VISA'
              // };

              // parse response and generate a masked ccNumber
              if (res) {
                _self.ccData = {
                  ccMasked: uteSemafoneService.getMaskedToken(res.ccNumber),
                  ccExpiryYear: res.ccExpiryDate.split('-')[0],
                  ccExpiryMonth: res.ccExpiryDate.split('-')[1],
                  ccType: buyUtils.getCCType().byFirstChar(res.ccType)
                };
                _self.ccNumber = res.ccNumber;

                console.log('@buyPaymentOptionsCtrl:$on.PaymentOptions.SelectedMethod: (_self)', _self);
                // should set scope with the previous card from ss
                angular.copy(_self.ccData, $scope.formData.pacc);
              }
            },
            function(res) {
              // notifier.notify.error();
            }
          );
        }
      }
    ]);
})();
